import React, { Component } from 'react';
import { connect } from 'react-redux';
import Link from 'react-router/lib/Link';
import * as Actions from '../actions';
import { get } from 'Language';

class ProfileDetails extends Component {

    componentWillMount() {
        const { getProfile } = this.props;
        getProfile();
    }
    
    render() {
        const { profile } = this.props;

        return (
            <div className="panel-custom-wrapper">
                <div className="panel panel-custom">
                    <div className="panel-heading">
                        { get('PROFILE_LINK') }
                        <Link to={`/profile/${profile.username}/edit`} 
                            className="btn btn-primary btn-xs pull-right">
                            <i className="fa fa-pencil"></i> Modify
                        </Link>
                    </div>

                    <ul className="list-group">
                        <li className="list-group-item clearfix">
                            <div className="col-md-2 col-xs-6">
                                { get('PROFILE_FNAME') }
                            </div>
                            <div className="col-md-10 col-xs-6">
                                { profile.first }
                            </div>
                        </li>
                        <li className="list-group-item clearfix">
                            <div className="col-md-2 col-xs-6">
                                { get('PROFILE_LNAME') }
                            </div>
                            <div className="col-md-10 col-xs-6">
                                { profile.last }
                            </div>
                        </li>
                        <li className="list-group-item clearfix">
                            <div className="col-md-2 col-xs-6">
                                { get('PROFILE_GENDER') }
                            </div>
                            <div className="col-md-10 col-xs-6">
                                { profile.gender }
                            </div>
                        </li>
                        <li className="list-group-item clearfix">
                            <div className="col-md-2 col-xs-6">
                                { get('PROFILE_FNAME') }
                            </div>
                            <div className="col-md-10 col-xs-6">
                                { profile.bod }
                            </div>
                        </li>
                        <li className="list-group-item clearfix">
                            <div className="col-md-2 col-xs-6">
                                 { get('PROFILE_PHONE') }
                            </div>
                            <div className="col-md-10 col-xs-6">
                                { profile.phone }
                            </div>
                        </li>
                        <li className="list-group-item clearfix">
                            <div className="col-md-2 col-xs-6">
                                 { get('PROFILE_ADDR1') }
                            </div>
                            <div className="col-md-10 col-xs-6">
                                { profile.addr1 }
                            </div>
                        </li>
                        <li className="list-group-item clearfix">
                            <div className="col-md-2 col-xs-6">
                                { get('PROFILE_ADDR2') }
                            </div>
                            <div className="col-md-10 col-xs-6">
                                { profile.addr2 }
                            </div>
                        </li>
                        <li className="list-group-item clearfix">
                            <div className="col-md-2 col-xs-6">
                                { get('PROFILE_CITY') }
                            </div>
                            <div className="col-md-10 col-xs-6">
                                { profile.city }
                            </div>
                        </li>
                        <li className="list-group-item clearfix">
                            <div className="col-md-2 col-xs-6">
                                { get('PROFILE_STATE') }
                            </div>
                            <div className="col-md-10 col-xs-6">
                                { profile.state }
                            </div>
                        </li>
                        <li className="list-group-item clearfix">
                            <div className="col-md-2 col-xs-6">
                                { get('PROFILE_ZIP') }
                            </div>
                            <div className="col-md-10 col-xs-6">
                                { profile.zip }
                            </div>
                        </li>
                        <li className="list-group-item clearfix">
                            <div className="col-md-2 col-xs-6">
                                { get('PROFILE_COUNTRY') }
                            </div>
                            <div className="col-md-10 col-xs-6">
                                { profile.country_name }
                            </div>
                        </li>
                        <li className="list-group-item clearfix">
                            <div className="col-md-2 col-xs-6">
                                { get('PROFILE_SPORT') }
                            </div>
                            <div className="col-md-10 col-xs-6">
                                { profile.sport_name }
                            </div>
                        </li>
                        { parseInt(profile.fitter, 10) === 1 
                            ? <li className="list-group-item clearfix">
                                <div className="col-md-2 col-xs-6">
                                    { get('PROFILE_COORDINATE') }
                                </div>
                                <div className="col-md-10 col-xs-6">
                                    { profile.long } (Long), { profile.lat } (Lat)
                                </div>
                            </li>
                            : null
                        }
                </ul>
            </div>
        </div>
        );
    }
}

export default connect(
    state => {
        const { profile } = state.profile;

        return {
            profile
        }
    },
    Actions
)(ProfileDetails)



// WEBPACK FOOTER //
// ./src/profile/containers/ProfileDetails.js